import { Box, Pagination, TablePagination } from '@mui/material';
import {
    GridApiPro,
    gridPageCountSelector,
    gridPaginationModelSelector,
    useGridSelector,
    gridPaginationRowCountSelector,
} from '@mui/x-data-grid-pro';
import { ChangeEvent, MutableRefObject } from 'react';

type Props = {
    apiRef: MutableRefObject<GridApiPro>;
    onPaginationChange: (newModel: { page: number; pageSize: number }) => void;
    label: string;
    pluralLabel: string;
    className?: string;
};

const CustomPagination = ({ apiRef, onPaginationChange, label, className, pluralLabel }: Props) => {
    const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
    const { page, pageSize } = paginationModel;
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const items = useGridSelector(apiRef, gridPaginationRowCountSelector);

    const handlePageChange = (_: any, newPage: number) => {
        onPaginationChange({ page: newPage, pageSize });
    };

    const handleRowsPerPageChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newPageSize = parseInt(event.target.value, 10);
        onPaginationChange({ page: 0, pageSize: newPageSize }); // reset to page 0 on size change
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
            <TablePagination
                component="div"
                count={items}
                page={page}
                onPageChange={handlePageChange}
                rowsPerPage={pageSize}
                onRowsPerPageChange={handleRowsPerPageChange}
                rowsPerPageOptions={[25, 50, 100, 500, 1000]}
                labelRowsPerPage={`${label} par page`}
                labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} sur ${count} ${count > 1 ? pluralLabel : label}`
                }
                ActionsComponent={() => null}
            />
            <Pagination
                className={className}
                count={pageCount}
                page={page + 1}
                onChange={(_, newPage) => handlePageChange(null, newPage - 1)} // conversion to 0-based
                shape="rounded"
                siblingCount={2}
                sx={{
                    '& .MuiPaginationItem-root.Mui-selected': {
                        backgroundColor: '#295EEF',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '28px',
                    },
                    '& .MuiPaginationItem-root': {
                        borderRadius: '50%',
                    },
                    '& .MuiPaginationItem-root.MuiPaginationItem-previousNext': {
                        color: '#132155',
                    },
                    '& .MuiPaginationItem-root.MuiPaginationItem-previousNext.Mui-disabled': {
                        color: '#132155',
                        opacity: 1,
                    },
                }}
            />
        </Box>
    );
};

export default CustomPagination;
